import { createTheme } from "@mui/material";

// Global border radius variable
const BORDER_RADIUS = 22; // px
const ACCORDION_RADIUS = BORDER_RADIUS / 1.5; // 13.5px

// Factory to build theme using a configurable primary color + direction
const buildTheme = (primaryColor = "#BC1F41", direction = "rtl") =>
  createTheme({
    direction,
    typography: {
      fontFamily: "Dubai, Arial, sans-serif",
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: `${BORDER_RADIUS}px`,
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            borderRadius: `${ACCORDION_RADIUS}px !important`,
            overflow: "hidden",
            "&:before": {
              display: "none",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& input": {
              filter: "drop-shadow(0px 3px 3px rgba(0,0,0,0.16 ))",
              border: "1px solid #E4E9EF!important",
              borderRadius: 14,
            },
            "& .MuiInputBase-root": {
                         borderRadius: 14,
              backgroundColor: "#fff",
            },
          },
        },
      },
    },
    palette: {
      primary: {
        main: primaryColor,
      },
    },
  });

export default buildTheme;
